import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { withStyles } from '@material-ui/core';
import { withAlert } from 'react-alert';
import { Userpilot } from 'userpilot';

import HUBContext from '../../../services/HUBContext'
import { CarouselArrowRightIcon } from '../../../common/icons';
import hubAPI from '../../../services/hubAPI';

const styles = theme => ({
    fineAddsContainer: {
        display: 'flex',
        padding: '14px 24px',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'flex-start',
        gap: '8px',
        alignSelf: 'stretch',
        borderRadius: '8px',
        background: 'var(--warning-newness-newness-10, #E7F3FF)',

        '& > div': {
            display: 'flex',
            alignSelf: 'stretch',
            alignItems: 'center'
        },
        '& b': {
            color: 'var(--warning-newness-newness, #0D8AFF)',
            padding: '0px 4px',
            fontWeight: 500
        }
    },
    fineHomeAddsContainer: {
        display: 'flex',
        padding: '4px 16px',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'flex-start',
        gap: '8px',
        alignSelf: 'stretch',
        borderRadius: '8px',
        background: 'var(--warning-newness-newness-10, #E7F3FF)',

        '& > div': {
            display: 'flex',
            alignSelf: 'stretch',
            alignItems: 'center'
        },
        '& b': {
            color: 'var(--warning-newness-newness, #0D8AFF)',
            padding: '0px 4px',
            fontWeight: 400
        }
    },
    childrenContainer: {
        flexGrow: 1
    },
    linkButton: {
        color: 'var(--warning-newness-newness, #0D8AFF) !important',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: 'normal',
        backgroundColor: 'transparent',
        padding: '3px 8px',

        '&:hover': {
            backgroundColor: 'transparent !important',

            '& svg': {
                '& path': {
                    fill: 'var(--warning-newness-newness, #0D8AFF)'
                }
            }
        },
        '& svg': {
            '& path': {
                fill: 'var(--warning-newness-newness, #0D8AFF)'
            }
        },
        '&:active':{
            boxShadow: '0px 0px 0px 4px transparent !important',
            color: '#00A184 !important'
        }
    }
});

export class FineModuleAdds extends Component {

    hiddenStates = [true, undefined]
    state = {
        enabled: undefined
    }

    componentDidMount() {
        const { company } = this.context;
        this.mount = true;

        this.setState({ companyID: company?.companyID || 0 }, () => this.getData());
    }

    componentDidUpdate() {
        if (!this.mount) return;
        const { companyID } = this.state;
        const { company } = this.context;

        if ((company?.companyID || 0) !== companyID) {
            this.setState({ companyID: company?.companyID || 0 }, () => this.getData());
        }
    }

    getData = () => {
        const { locale, company } = this.context;
        
        hubAPI.get(`/api/v1/Company/${company?.companyID || 0}/finescheckproplanenabled?culture=${locale}`)
        .then(r => {
            if (!this.mount) return;
            const { enabled } = r.data

            this.setState({ enabled });
        })
        .catch(_ => {
            this.setState({ enabled: undefined });
        });
    }

    handleUserPilotOnClick = () => Userpilot.trigger("1694612535yLxt9574");
    
    render() {
        const { enabled } = this.state
        const { classes, children, useInHome } = this.props;

        if (this.hiddenStates.includes(enabled))
            return null

        return <div className={useInHome ? classes.fineHomeAddsContainer : classes.fineAddsContainer}>
            <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path fillRule="evenodd" clipRule="evenodd" d="M8.48165 1.34545C8.57886 1.13419 8.78223 1 9.00524 1C9.22824 1 9.43162 1.13419 9.52882 1.34545L11.6802 5.92362L16.5018 6.65848C16.7213 6.69202 16.9036 6.85403 16.9718 7.07619C17.04 7.29835 16.9823 7.54201 16.8229 7.70443L13.3324 11.2562L14.1561 16.2778C14.1936 16.5072 14.1042 16.7391 13.9256 16.8763C13.7469 17.0134 13.5098 17.0321 13.3138 16.9245L9.00407 14.5558L4.68625 16.9306C4.49018 17.0382 4.25309 17.0196 4.07442 16.8824C3.89576 16.7452 3.80641 16.5133 3.84386 16.2839L4.66763 11.2624L1.17707 7.71055C1.01773 7.54813 0.96 7.30448 1.02821 7.08231C1.09642 6.86015 1.2787 6.69815 1.4982 6.6646L6.32099 5.92975L8.48165 1.34545Z" fill="#0D8AFF" stroke="#0D8AFF" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </div>

            <div className={classes.childrenContainer}>
                {children}
            </div>

            <div>
                <button onClick={ this.handleUserPilotOnClick } className={`v3-button secondary ${classes.linkButton}`} >
                    <FormattedMessage id='fines.showPackages' defaultMessage='To know' />
                    <CarouselArrowRightIcon />
                </button>
            </div>
        </div>
    }
}

FineModuleAdds.contextType = HUBContext;
export default withAlert()(withStyles(styles)(injectIntl(FineModuleAdds)));
